module.exports = __webpack_public_path__ + "images/shuffle_grey@1x.png?25e54ade";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shuffle_grey@1x.png
// module id = 704
// module chunks = 7